import React from 'react'
import { Button, ButtonProps, Spinner } from 'react-bootstrap'

interface LoadingButtonProps extends ButtonProps {
    loading?: boolean
    loadingText?: string
    icon?: string
    children: React.ReactNode
}

/**
 * LoadingButton Component
 * Button with built-in loading state and spinner
 */
const LoadingButton: React.FC<LoadingButtonProps> = ({
    loading = false,
    loadingText = 'Loading...',
    icon,
    children,
    disabled,
    ...props
}) => {
    return (
        <Button {...props} disabled={loading || disabled}>
            {loading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                    {loadingText}
                </>
            ) : (
                <>
                    {icon && <i className={`${icon} me-2`}></i>}
                    {children}
                </>
            )}
        </Button>
    )
}

export default LoadingButton
